import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://ygalaad.com";
const DEFAULT_OG_IMAGE = `${BASE_URL}/assets/ygalaad_icon_transparent.svg`;

function setMetaProperty(name, content, isProperty = true) {
  const attr = isProperty ? "property" : "name";
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.getElementsByTagName("head")[0].appendChild(el);
  }
  el.setAttribute("content", content);
}

function SEO() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const origin = typeof window !== "undefined" ? window.location.origin : BASE_URL;
    const canonicalUrl = `${origin}${path}`;

    let title =
      "YGALAAD - Innovative Software Solutions & Mobile Apps Development";
    let description =
      "YGALAAD creates cutting-edge software solutions and mobile applications that transform businesses.";

    if (path.includes("support")) {
      title = "Support - YGALAAD";
      description =
        "Get support for YGALAAD apps and services. Contact our team for technical assistance.";
    } else if (path.includes("privacy-policy")) {
      title = "Privacy Policy - YGALAAD";
      description = "Privacy Policy for YGALAAD applications and services.";
    } else if (path.includes("master-sudoku-challenge")) {
      title = "Master Sudoku Challenge - YGALAAD";
      description =
        "Challenge your mind with a variety of Sudoku puzzles. Perfect for beginners and experts alike.";
    } else if (path.includes("sparkle")) {
      title = "Sparkle - Cleaning Company Management App - YGALAAD";
      description =
        "Streamline cleaning company operations with smart scheduling, task management, and client communications.";
    } else if (path.includes("probat")) {
      title = "ProBat - Professional Screed Management App - YGALAAD";
      description =
        "The mobile app for screed professionals. Track projects, manage sites, and simplify workflows.";
} else if (path.includes("passcrypt")) {
        title = "PassCrypt Suite - Cybersecurity - YGALAAD";
        description =
          "Cybersecurity suite for password management and secure access. Protect your credentials and simplify compliance.";
      } else if (path.includes("pandagpt")) {
        title = "PandaGPT - On-Premise ChatGPT-like with RAG - YGALAAD";
        description =
          "On-premise ChatGPT-like assistant based on open-source LLMs with custom RAG. Your data stays in-house.";
      } else if (path.includes("stage-ingenieur")) {
      title = path.startsWith("/fr")
        ? "Stage Ingénieur Développement – YGALAAD"
        : "Developer Internship – YGALAAD";
      description =
        path.startsWith("/fr")
          ? "Stage structurant en développement, SaaS et architecture. Encadrement senior, projets concrets."
          : "Structured internship in development, SaaS and architecture. Senior mentoring, concrete projects.";
    } else if (path.includes("/stage-sales-marketing")) {
      title = path.startsWith("/fr")
        ? "Stage IA & Business Development – YGALAAD"
        : "AI & Business Development Internship – YGALAAD";
      description =
        path.startsWith("/fr")
          ? "Stage structurant en IA appliquée, SaaS et développement d'activité. Encadrement senior, projets concrets."
          : "Structured internship in applied AI, SaaS and business development. Senior mentoring, concrete projects.";
    }

    document.title = title;

    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", description);
    } else {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      metaDescription.content = description;
      document.getElementsByTagName("head")[0].appendChild(metaDescription);
    }

    // Open Graph (absolute URLs for crawlers that run JS; for /fr/stage-sales-marketing without JS, server should inject these)
    setMetaProperty("og:title", title);
    setMetaProperty("og:description", description);
    setMetaProperty("og:url", canonicalUrl);
    setMetaProperty("og:image", DEFAULT_OG_IMAGE);
    setMetaProperty("og:type", "website");

    setMetaProperty("twitter:card", "summary_large_image", false);
    setMetaProperty("twitter:title", title, false);
    setMetaProperty("twitter:description", description, false);
    setMetaProperty("twitter:image", DEFAULT_OG_IMAGE, false);
  }, [location]);

  return null;
}

export default SEO;
